import { Navigate, useParams } from 'react-router-dom';

/**
 * Legacy service URLs used …/service/:slug. Canonical path is …/:slug.
 */
const StorefrontServicePathLegacyRedirect = () => {
  const { companyUrl, serviceSlug } = useParams();
  if (!companyUrl || !serviceSlug) {
    return <Navigate to="/book" replace />;
  }
  return <Navigate to={`/book/${companyUrl}/${encodeURIComponent(serviceSlug)}`} replace />;
};

export default StorefrontServicePathLegacyRedirect;
